document.addEventListener('DOMContentLoaded', function () {
  var burger = document.querySelector('.site-header__burger');
  var nav = document.querySelector('.site-header__nav');
  var mobileQuery = window.matchMedia('(max-width: 880px)');

  if (!burger || !nav) return;

  nav.id = nav.id || 'bf-primary-navigation';
  burger.setAttribute('aria-controls', nav.id);
  burger.setAttribute('aria-expanded', 'false');

  var dropdowns = Array.prototype.slice.call(nav.querySelectorAll('.nav-drop'));

  dropdowns.forEach(function (dropdown, index) {
    var trigger = dropdown.querySelector('.nav-drop__trigger');
    var panel = dropdown.querySelector('.nav-drop__panel');
    if (!trigger || !panel) return;

    panel.id = panel.id || 'bf-submenu-' + index;
    trigger.setAttribute('aria-controls', panel.id);
    trigger.setAttribute('aria-expanded', 'false');

    trigger.addEventListener('click', function (event) {
      if (!mobileQuery.matches) return;

      event.preventDefault();
      event.stopPropagation();

      var shouldOpen = !dropdown.classList.contains('is-open');

      dropdowns.forEach(function (item) {
        item.classList.remove('is-open');
        var itemTrigger = item.querySelector('.nav-drop__trigger');
        if (itemTrigger) itemTrigger.setAttribute('aria-expanded', 'false');
      });

      if (shouldOpen) {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  function closeDropdowns() {
    dropdowns.forEach(function (dropdown) {
      dropdown.classList.remove('is-open');
      var trigger = dropdown.querySelector('.nav-drop__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function closeMenu() {
    nav.classList.remove('is-mobile-open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('bf-mobile-menu-open');
    closeDropdowns();
  }

  burger.addEventListener('click', function () {
    var shouldOpen = !nav.classList.contains('is-mobile-open');
    nav.classList.toggle('is-mobile-open', shouldOpen);
    burger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    document.body.classList.toggle('bf-mobile-menu-open', shouldOpen);

    if (!shouldOpen) closeDropdowns();
  });

  nav.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (link && mobileQuery.matches) closeMenu();
  });

  document.addEventListener('click', function (event) {
    if (!mobileQuery.matches || !nav.classList.contains('is-mobile-open')) return;
    if (!event.target.closest('.site-header')) closeMenu();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMenu();
      burger.focus();
    }
  });

  function resetForViewport() {
    if (!mobileQuery.matches) closeMenu();
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', resetForViewport);
  } else {
    mobileQuery.addListener(resetForViewport);
  }
});
